var main = {
    preventDefaultForHashLinks: function() {
        // Get all anchor elements
        var anchorElements = document.querySelectorAll('a');

        // Loop through the anchor elements
        anchorElements.forEach(function(anchor) {
            // Check if the href attribute contains #
            if (anchor.getAttribute('href') && anchor.getAttribute('href').includes('#')) {
                anchor.addEventListener('click', function(event) {
                    event.preventDefault();

                    // Get the target ID from the href
                    var targetId = anchor.getAttribute('href').substring(1); // Remove the #

                    // Check if an element with the target ID exists in the DOM
                    var targetElement = document.getElementById(targetId);

                    if (targetElement) {
                        // Define an offset (adjust this value as needed)
                        var offsetTop = 50; // Change this to your desired offset

                        // Scroll to the target element with the specified offset
                        window.scrollTo({
                            top: targetElement.offsetTop - offsetTop,
                            behavior: 'smooth' // You can change this to 'auto' for an instant scroll
                        });
                    }
                });
            }
        });
    },
    megaBlocks: function() {
        document.querySelectorAll('.shopby-item').forEach(e=> {
            e.addEventListener('click', function() {
                const name = e.dataset.menuTree

                document.querySelectorAll('.shopby-item').forEach(shopby=> {
                  shopby.classList.remove('active')
                })

                e.classList.add('active')

                document.querySelectorAll('.panel-mega-item').forEach(e=> {
                    e.style.display = 'none'
                })
                
                const activePanel = Array.from(document.querySelectorAll('.panel-mega-item'))
                .filter(e => e.dataset.linkName === name);
                
                activePanel[0].style.display = 'block'
            })
        })

        // document.querySelectorAll('.shopby-item')[0]?.click()
    },
    jsToggles: function() {
        var linkToggle = document.querySelectorAll('.js-toggle');

        for(i = 0; i < linkToggle.length; i++) {
        linkToggle[i].addEventListener('click', function(event) {
        
          event.preventDefault();
          
          var container = document.getElementById(this.dataset.container);
        
          if (!container.classList.contains('active')) {
            this.classList.add('is-open');
            container.classList.add('active');
            container.style.height = 'auto';
        
            var height = container.clientHeight + 'px';
        
            container.style.height = '0px';
        
            var parentContainer = container.closest('.sub-parent')
        
        
            setTimeout(function () {
              container.style.height = height;
                if (parentContainer != undefined && parentContainer.clientHeight > 0) {
                  setTimeout( function() {
                    parentContainer.style.height = 'auto';
                    var parentHeight = parentContainer.clientHeight + 'px';
            
                    parentContainer.style.height = '0px';
        
                      parentContainer.style.height = parentHeight;
                  }, 100)
                }
            }, 0);
            
          } else {
            this.classList.remove('is-open');
            
            container.style.height = '0px';
        
            if (container.classList.contains('no-trans')) {
              container.classList.remove('active');
            } else {
              container.addEventListener('transitionend', function () {
                container.classList.remove('active');
              }, {
                once: true
              });
            }
            
            setTimeout(function () {
              var parentContainer = container.closest('.sub-parent')
              var innerSub = container.closest('.inner-sub')
        
              if (innerSub != null) {
                parentContainer.style.height = innerSub.clientHeight + 'px';
              }
            }, 100);
          }
          
        });
        
        }
    }
}

main.preventDefaultForHashLinks()
main.megaBlocks()
main.jsToggles()


class ButtonToggle extends HTMLElement {
  constructor() {
      super();
      // You should use addEventListener to attach an event listener to an element.
      this.addEventListener('click', this.initToggle.bind(this));
  }

  initToggle() {
    const parent = this.closest('.options-toggler')
    const text = this.querySelector('.toggle-text')
    parent.classList.toggle('active')

    if (parent.classList.contains('active')) {
      text.textContent = this.dataset.lessText
    } else {
      text.textContent = this.dataset.moreText
    }
  }
}

// Register the custom element
customElements.define('button-toggle', ButtonToggle);